import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { IUser } from '~/models';
import { selectedOfficeService } from '../selectedOfficeService';

export function useGetSelectedOffice(officeId: string) {
  const dispatch = useDispatch();

  return useMutation<IUser>({
    mutationFn: () => selectedOfficeService.getSelectedOffice({ officeId }),
    onSuccess: (data) => {
      dispatch({ type: 'SET_SELECTED_OFFICE', payload: data });
    },
  });
}
